module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 15);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("tslib");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var VAS_NAMES = {
    auction: 'Аукцион',
    colorized: '',
    payed: 'Платное',
    premium: 'Премиум',
    top3: 'Топ 3',
};
var ML_VAS_NAMES = {
    auction: 'Аукцион',
    colorized: '',
    payed: 'Платное',
    premium: 'Премиум',
    top3: 'Топ',
};
var FULL_VAS_NAMES = {
    auction: 'Аукцион',
    colorized: 'Выделение цветом',
    payed: 'Платное',
    premium: 'Премиум',
    top3: 'Топ 3',
};
var ML_FULL_VAS_NAMES = {
    auction: 'Аукцион',
    colorized: 'Выделение цветом',
    payed: 'Платное',
    premium: 'Премиум',
    top3: 'Топ',
};
// Отключил в этом объекте длину строки, чтобы не извращаться с переносом строк
// tslint:disable:max-line-length
var VAS_DESCRIPTIONS = {
    auction: 'Объявления пользователей, которые заплатили больше, показываются на более высоких позициях.',
    colorized: 'Яркий жёлтый фон выделит ваше объявление на фоне других.',
    payed: 'Объявления будут показаны после Топ-объявлений и всех Премиумов.',
    premium: 'Объявления показываются сразу под Топ-объявлениями, но перед Платными.',
    top3: 'Объявления занимают первые три позиции на странице результатов поиска. Можно добавить к объявлению свой логотип.',
};
var ML_VAS_DESCRIPTIONS = {
    auction: 'Аукцион – это способ увеличить частоту показов вашего объявления. Чем выше ставка, тем чаще ваше объявление будет показано в результатах поиска.',
    colorized: 'Ваше объявление будет выделено ярким цветом на фоне других объявлений.',
    payed: 'Платные объявления никак не выделяются в результатах поиска и показываются в 3 раза реже, чем Топ-объявления.',
    premium: 'Премиум-объявления выделены в результатах поиска за счёт дополнительных фотографий. Такие объявления показываются в 1.5 раза чаще обычных.',
    top3: 'Топ-объявления самые заметные в результатах поиска за счёт больших фотографий и брендирования. Такие объявления показываются в 3 раза чаще обычных.',
};
// tslint:enable:max-line-length
/**
 * Возвращает имя VAS с самым высоким приоритетом
 * @param vasList список VAS'ов объявления, отсортированный по приоритету
 */
function getTopVasName(vasList) {
    return VAS_NAMES[vasList[0]];
}
exports.getTopVasName = getTopVasName;
/**
 * Возвращает имя VAS по заданной мнемонике (например, premium => Премиум)
 * @param vas мнемоника VAS
 * @param useFullNames указывать на необходимость возвращать полные имена всех VAS
 */
function getVasName(vas, useFullNames) {
    return useFullNames ? FULL_VAS_NAMES[vas] : VAS_NAMES[vas];
}
exports.getVasName = getVasName;
/**
 * Возвращает описание VAS и его преимущества
 * @param vas мнемоника VAS
 */
function getVasDescription(vas) {
    return VAS_DESCRIPTIONS[vas];
}
exports.getVasDescription = getVasDescription;
/**
 * Возвращает имя VAS с самым высоким приоритетом (с учетом ранжированной выдачи)
 * @param vasList список VAS'ов объявления, отсортированный по приоритету
 */
function getMlTopVasName(vasList) {
    return ML_VAS_NAMES[vasList[0]];
}
exports.getMlTopVasName = getMlTopVasName;
/**
 * Возвращает имя VAS по заданной мнемонике (с учетом ранжированной выдачи)
 * например, premium => Премиум
 * @param vas мнемоника VAS
 * @param useFullNames указывать на необходимость возвращать полные имена всех VAS
 */
function getMlVasName(vas, useFullNames) {
    return useFullNames ? ML_FULL_VAS_NAMES[vas] : ML_VAS_NAMES[vas];
}
exports.getMlVasName = getMlVasName;
/**
 * Возвращает описание VAS и его преимущества (с учетом ранжированной выдачи)
 * @param vas мнемоника VAS
 */
function getMlVasDescription(vas) {
    return ML_VAS_DESCRIPTIONS[vas];
}
exports.getMlVasDescription = getMlVasDescription;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PRIORITIES = {
    auction: 4,
    colorized: 1,
    payed: 2,
    premium: 3,
    top3: 5,
};
function sortVas(vasList, priorities) {
    if (priorities === void 0) { priorities = PRIORITIES; }
    return vasList.slice(0).sort(function (a, b) {
        var aPriority = priorities[a];
        var bPriority = priorities[b];
        // Не переписывать на тернарник, иначе падают тесты
        if (aPriority <= bPriority) {
            return 1;
        }
        return -1;
    });
}
exports.sortVas = sortVas;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2), exports);
tslib_1.__exportStar(__webpack_require__(3), exports);
tslib_1.__exportStar(__webpack_require__(4), exports);
tslib_1.__exportStar(__webpack_require__(5), exports);
tslib_1.__exportStar(__webpack_require__(6), exports);
tslib_1.__exportStar(__webpack_require__(7), exports);
tslib_1.__exportStar(__webpack_require__(8), exports);
tslib_1.__exportStar(__webpack_require__(9), exports);
tslib_1.__exportStar(__webpack_require__(10), exports);
tslib_1.__exportStar(__webpack_require__(11), exports);
tslib_1.__exportStar(__webpack_require__(12), exports);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var defaultCookieOptions = {
    domain: '.cian.ru',
    path: '/',
    secure: true,
};
exports.setCookie = function (name, value, config) {
    var options = Object.assign({}, defaultCookieOptions, config);
    var expires = options.expires;
    var cookieExpires;
    if (expires) {
        if (typeof expires === 'number') {
            var d = new Date();
            cookieExpires = new Date(d.setTime(d.getTime() + expires * 1000)).toUTCString();
        }
        else if (expires instanceof Date) {
            cookieExpires = expires.toUTCString();
        }
    }
    document.cookie =
        // tslint:disable-next-line:prefer-template
        name + "=" + encodeURIComponent(value) + "; " +
            ("path=" + options.path) +
            ("; domain=" + options.domain) +
            (cookieExpires ? "; expires=" + cookieExpires : '') +
            (options.secure ? "; secure" : '');
};
exports.deleteCookie = function (name, config) {
    exports.setCookie(name, '', Object.assign({}, config, {
        expires: -1,
    }));
};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var hostPatterns = [
    ['beta', /stage\.cian\.ru$/i],
    ['development', /dev[2,3]?\.cian\.ru$/i],
    ['local', /local(\.map)?\.cian\.ru$/i],
    ['local', /^localhost(:\d+)?$/i],
    ['production', /cian\.ru$/i],
];
function calculateEnvironmentByHost(host) {
    for (var _i = 0, hostPatterns_1 = hostPatterns; _i < hostPatterns_1.length; _i++) {
        var hostPattern = hostPatterns_1[_i];
        if (hostPattern[1].test(host)) {
            return hostPattern[0];
        }
    }
    return 'unknown';
}
exports.calculateEnvironmentByHost = calculateEnvironmentByHost;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCookies = function (cookiesString) {
    var cookiesObject = {};
    var pairs = cookiesString.split(/; */);
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i];
        var eqIdx = pair.indexOf('=');
        // skip things that don't look like key=value
        if (eqIdx < 0) {
            continue;
        }
        var key = pair.substr(0, eqIdx).trim();
        // tslint:disable-next-line:restrict-plus-operands
        var value = pair.substr(eqIdx + 1, pair.length).trim();
        // quoted values
        if (value[0] === '"') {
            value = value.slice(1, -1);
        }
        // only assign once
        if (!(key in cookiesObject)) {
            cookiesObject[key] = decodeURIComponent(value);
        }
    }
    return cookiesObject;
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var monthNames = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
];
function isValidDate(date) {
    return !isNaN(date.getTime());
}
exports.isValidDate = isValidDate;
function leftPadZero(value) {
    if (value < 10) {
        return "0" + value;
    }
    return value.toString();
}
exports.leftPadZero = leftPadZero;
function getTime(date) {
    return leftPadZero(date.getHours()) + ":" + leftPadZero(date.getMinutes());
}
exports.getTime = getTime;
function mapDayToString(date, now) {
    if (!now || !isValidDate(now)) {
        now = new Date();
    }
    else {
        now = new Date(now.getTime());
    }
    if (now.getFullYear() !== date.getFullYear() || now.getMonth() !== date.getMonth()) {
        return undefined;
    }
    if (now.getDate() === date.getDate()) {
        return 'сегодня';
    }
    now.setDate(now.getDate() - 1);
    if (now.getDate() === date.getDate()) {
        return 'вчера';
    }
    now.setDate(now.getDate() - 1);
    if (now.getDate() === date.getDate()) {
        return 'позавчера';
    }
    return undefined;
}
exports.mapDayToString = mapDayToString;
function getFormattedDate(date, now) {
    var day = mapDayToString(date);
    if (!now || !isValidDate(now)) {
        now = new Date();
    }
    else {
        now = new Date(now.getTime());
    }
    if (day) {
        return day + " " + getTime(date);
    }
    if (now.getFullYear() === date.getFullYear()) {
        return date.getDate() + " " + monthNames[date.getMonth()] + " " + getTime(date);
    }
    return date.getDate() + " " + monthNames[date.getMonth()] + " " + date.getFullYear();
}
exports.getFormattedDate = getFormattedDate;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var devices = [
    {
        regex: /iPhone/i,
        type: 'phone',
    }, {
        regex: /iPod/i,
        type: 'phone',
    }, {
        regex: /iPad/i,
        type: 'tablet',
    }, {
        regex: /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i,
        type: 'phone',
    }, {
        regex: /Android/i,
        type: 'tablet',
    }, {
        regex: /Windows Phone/i,
        type: 'phone',
    }, {
        regex: /(?=.*\bWindows\b)(?=.*\bARM\b)/i,
        type: 'tablet',
    }, {
        regex: /(BlackBerry|BB10)/i,
        type: 'phone',
    }, {
        regex: /Opera Mini/i,
        type: 'phone',
    }, {
        regex: /(CriOS|Chrome)(?=.*\bMobile\b)/i,
        type: 'phone',
    }, {
        regex: /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i,
        type: 'phone',
    },
];
exports.identifyDeviceType = function (userAgent) {
    if (userAgent) {
        for (var i = 0; i < devices.length; i++) {
            var device = devices[i];
            if (device.regex.test(userAgent)) {
                return device.type;
            }
        }
    }
    return 'desktop';
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function normalizeHost(host) {
    var rules = [
        [/^([^\.]+)\.micro\.cian\.tech$/, undefined],
        [/^(?:[^\.]+\.)?beta\d*\.stage\.cian\.ru$/, 'python'],
        [/^[^\.]+\.([^\.]+)\.stage\.cian\.ru$/, undefined],
        [/^(?:[^\.]+\.)?[^\.]+\.dev\d*\.cian\.ru$/, 'python'],
        [/^(?:[^\.]+\.)?beta\d*\.cian\.ru$/, 'python'],
        [/^(?:[^\.]+\.)?cian\.ru$/, 'python'],
    ];
    for (var _i = 0, rules_1 = rules; _i < rules_1.length; _i++) {
        var _a = rules_1[_i], pattern = _a[0], name_1 = _a[1];
        var matches = pattern.exec(host);
        if (matches) {
            if (name_1) {
                return name_1;
            }
            else {
                return matches[1];
            }
        }
    }
    return host;
}
exports.normalizeHost = normalizeHost;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NOT_NUMBER_REX = /[^0-9]/g;
var NUMBER_GROUP_REX = /.{1,3}/g;
function parseNumber(s) {
    var sign = s[0] === '-' ? '-' : '';
    var _a = s.split('.'), integer = _a[0], fractional = _a[1];
    return {
        fractional: fractional ? fractional.replace(NOT_NUMBER_REX, '') : '',
        integer: integer.replace(NOT_NUMBER_REX, ''),
        sign: sign,
    };
}
exports.parseNumber = parseNumber;
function numberToPrettyString(defaultNumber, separator) {
    if (separator === void 0) { separator = ','; }
    var _a = parseNumber(String(defaultNumber)), fractional = _a.fractional, integer = _a.integer, sign = _a.sign;
    var parsedInteger = reverseString(integer).match(NUMBER_GROUP_REX) || [];
    var prettyInteger = parsedInteger.reverse().map(reverseString).join(' ');
    return !fractional ? "" + sign + prettyInteger : "" + sign + prettyInteger + separator + fractional;
}
exports.numberToPrettyString = numberToPrettyString;
function reverseString(s) {
    return s.split('').reverse().join('');
}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function plural(n, variants) {
    if (n % 10 === 1 && n % 100 !== 11) {
        return variants[0];
    }
    if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
        return variants[1];
    }
    return variants[2];
}
exports.plural = plural;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollTo = function (params) {
    var containerElementClientHeight = params.containerElement.clientHeight;
    var containerElementScrollTop = params.containerElement.scrollTop;
    var targetElementOffsetTop = params.targetElement.offsetTop;
    var targetElementScrollHeight = params.targetElement.scrollHeight;
    if (params.center) {
        params.containerElement.scrollTop =
            targetElementOffsetTop
                - containerElementClientHeight / 2
                + targetElementScrollHeight / 2;
    }
    else {
        var containerBottom = containerElementScrollTop + containerElementClientHeight;
        var valueBottom = targetElementOffsetTop + targetElementScrollHeight;
        if (valueBottom > containerBottom) {
            params.containerElement.scrollTop = valueBottom - containerElementClientHeight;
        }
        else if (targetElementOffsetTop < containerElementScrollTop) {
            params.containerElement.scrollTop = targetElementOffsetTop;
        }
    }
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var defaultOptions = {
    billionPostfix: 'млрд.',
    fractionalLength: 2,
    millionPostfix: 'млн.',
    separator: undefined,
    thousandPostfix: 'тыс.',
};
function shortenNumber(i, userOptions) {
    var options = userOptions
        ? Object.assign({}, defaultOptions, userOptions)
        : defaultOptions;
    var getFractional = fractional(options.fractionalLength);
    var applyPostfix = withPostfix(options.separator);
    if (i >= 1000000000) {
        var value = getFractional(i, 1000000000);
        return applyPostfix(value, options.billionPostfix);
    }
    else if (i >= 1000000) {
        var value = getFractional(i, 1000000);
        return applyPostfix(String(value), options.millionPostfix);
    }
    else if (i >= 1000) {
        var value = getFractional(i, 1000);
        return applyPostfix(value, options.thousandPostfix);
    }
    else {
        var value = getFractional(i);
        return applySeparator(Number(value), options.separator);
    }
}
exports.shortenNumber = shortenNumber;
function withPostfix(separator) {
    return function (value, postfix) {
        return applySeparator(Number(value), separator) + " " + postfix;
    };
}
function fractional(fractionalLength) {
    return function (value, divider) {
        if (!divider) {
            return value.toFixed(fractionalLength);
        }
        var num = value / divider;
        var numAsArray = String(num).split('.');
        var originalFractionChapter = numAsArray[1];
        if (originalFractionChapter &&
            originalFractionChapter.length > 2 &&
            Number(originalFractionChapter.slice(-1)) < 5) {
            return num.toFixed(fractionalLength);
        }
        else if (originalFractionChapter) {
            var newFractionChapter = originalFractionChapter.length > fractionalLength
                ? originalFractionChapter.slice(0, fractionalLength)
                : originalFractionChapter;
            return numAsArray[0] + "." + newFractionChapter;
        }
        return String(num);
    };
}
function applySeparator(value, separator) {
    if (typeof separator === 'string') {
        return value.toString().replace('.', separator);
    }
    return value.toString();
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function isStyleProps(styleArgument) {
    if (!!styleArgument && typeof styleArgument === 'object' && !Array.isArray(styleArgument)) {
        return styleArgument.hasOwnProperty('style') && styleArgument.hasOwnProperty('className');
    }
    return false;
}
function mergeClassNames(target, cls) {
    if (!cls || !cls.length) {
        return target;
    }
    return target.length === 0
        ? cls
        : target + " " + cls;
}
function mergeStyleProperties(target, style) {
    return tslib_1.__assign({}, target, style);
}
function mergerStyleConfigs(target, style) {
    return {
        className: mergeClassNames(target.className, style.className),
        style: mergeStyleProperties(target.style, style.style),
    };
}
// tslint:disable-next-line:no-any
function isStyleConifg(target) {
    if (!target) {
        return false;
    }
    return typeof target === 'object' || typeof target === 'string';
}
function reducer(acc, style) {
    if (!isStyleConifg(style)) {
        return acc;
    }
    if (Array.isArray(style)) {
        return style.reduce(reducer, acc);
    }
    if (typeof style === 'object') {
        return isStyleProps(style)
            ? mergerStyleConfigs(acc, style)
            : mergerStyleConfigs(acc, { className: '', style: style });
    }
    acc.className = mergeClassNames(acc.className, style);
    return acc;
}
function mergeStyles() {
    var styles = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        styles[_i] = arguments[_i];
    }
    return styles.reduce(reducer, { style: {}, className: '' });
}
exports.mergeStyles = mergeStyles;


/***/ })
/******/ ]);
//# sourceMappingURL=frontend-utils.js.map

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(1);
exports.LittleAuctionIcon = function (isHovered, props) { return (React.createElement("svg", tslib_1.__assign({}, props, { xmlns: "http://www.w3.org/2000/svg", width: "13", height: "14", viewBox: "0 0 13 14" }),
    React.createElement("path", { fill: isHovered ? '#CC6E09' : '#FF8400', fillRule: "nonzero", d: "M5.85 1.986l-.65-.662L6.5 0l3.9 3.972-1.3 1.325-.65-.663-3.9 3.973.65.662-1.3 1.324L0 6.621l1.3-1.324.65.662 3.9-3.973zm0 5.297l1.3-1.324L13 11.917l-1.3 1.324-5.85-5.958zm-5.318 5.72h5.874V14H.532v-.997zm.979-.997h3.916v.997H1.511v-.997z" }))); };


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(1);
exports.LittleColorizedIcon = function (isHovered, props) { return (React.createElement("svg", tslib_1.__assign({}, props, { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", viewBox: "0 0 14 14" }),
    React.createElement("path", { fill: isHovered ? '#CC6E09' : '#FF8400', fillRule: "evenodd", d: "M4.423 4.461a.328.328 0 0 0-.443 0L2.727 5.708a.328.328 0 0 0 0 .446c.584.587 1.151 1.572 1.014 2.352-.085.423-.383.771-.788.92-1.64.76-2.742 1.82-2.923 2.827-.1.478.053.974.404 1.313.338.352.834.504 1.312.403 1.007-.18 2.063-1.273 2.825-2.926.147-.404.494-.702.915-.788.777-.138 1.762.43 2.349 1.017a.328.328 0 0 0 .443 0l.61-.61-.899-.902a.3.3 0 0 1 .423-.423l.9.902.225-.227a.328.328 0 0 0 0-.446L4.423 4.461zm-2.054 8.407a.874.874 0 1 1-1.239-1.233.874.874 0 0 1 1.239 1.233zm11.338-8.58c.39.398.39 1.033.003 1.433L10.69 8.75l-.462-.444 3.02-3.03a.38.38 0 0 0 .068-.443l-1.063-.02a.338.338 0 0 1-.297-.438l.094-.232-.263.084a.338.338 0 0 1-.415-.39l.104-.394-.381.108a.338.338 0 0 1-.405-.39l.057-.23-1.41.77a.338.338 0 0 1-.425-.463l.843-1.219-.192.034a.338.338 0 0 1-.392-.316V.687a.382.382 0 0 0-.442.07l-3.02 3.03-.459-.459L8.27.3c.193-.194.456-.302.73-.3.274 0 .538.112.728.31.06.061.094.143.095.229v.807l.594-.145a.338.338 0 0 1 .337.502l-.526.76.86-.47a.338.338 0 0 1 .473.363l-.118.414.384-.111a.338.338 0 0 1 .415.407l-.097.37.337-.108a.338.338 0 0 1 .405.421l-.165.444h.762a.338.338 0 0 1 .223.095z" }))); };


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(1);
exports.LittlePayedIcon = function (isHovered, props) { return (React.createElement("svg", tslib_1.__assign({}, props, { xmlns: "http://www.w3.org/2000/svg", width: "9", height: "13", viewBox: "0 0 9 13" }),
    React.createElement("path", { fill: isHovered ? '#CC6E09' : '#FF8400', fillRule: "evenodd", d: "M0 6.656h1.286V0h3.066c1.483 0 2.472.208 3.164.832C8.406 1.456 9 2.496 9 3.952c0 1.144-.396 2.184-1.088 2.912-.89.936-1.879 1.352-3.66 1.352H2.869V9.36h5.539v1.456H2.868V13H1.187v-2.184H0v-1.56h1.286V8.112H0V6.656zm6.429-4.68c-.594-.312-1.187-.52-2.176-.52H2.868v5.2h1.088c1.385 0 2.077-.208 2.67-.728.495-.52.693-1.144.693-1.976 0-.832-.297-1.56-.89-1.976z" }))); };


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(1);
exports.LittlePremiumIcon = function (isHovered, props) { return (React.createElement("svg", tslib_1.__assign({}, props, { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", viewBox: "0 0 14 14" }),
    React.createElement("path", { fill: isHovered ? '#CC6E09' : '#FF8400', fillRule: "evenodd", d: "M1.292 12.707l1.939.646-.646.647H0v-2.585l.646-.646.646 1.938zm10.466-10.46c-.287-.29-1.219.153-1.65.589-.429.435-.545 1.023-.258 1.313.286.29.867.172 1.297-.263.43-.435.898-1.35.61-1.64zm.239 3.329L7.002 10.58V14h-1.4l-.806-1.21.299-.901-1.5-1.503.6.601-.6 1.803-.6-1.803-1.8-.6 1.8-.603-.9-.902-.9.301L0 8.399v-1.4h3.376l5.02-5.03S12.912-.722 13.82.187c.892.894-1.823 5.388-1.823 5.388z" }))); };


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(1);
exports.LittleTop3Icon = function (isHovered, props) { return (React.createElement("svg", tslib_1.__assign({}, props, { xmlns: "http://www.w3.org/2000/svg", width: "15", height: "15", viewBox: "0 0 15 15" }),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("circle", { cx: "7.5", cy: "7.5", r: "7", fill: isHovered ? '#CC6E09' : '#FF8400' }),
        React.createElement("path", { fill: "#FFF", d: "M11.5 9l-4-6.1-4 6.1H6v3h3V9z" })))); };


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(1);
exports.BigAuctionIcon = function (id, props) { return (React.createElement("svg", tslib_1.__assign({}, props, { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "37", viewBox: "0 0 40 37" }),
    React.createElement("defs", null,
        React.createElement("linearGradient", { id: "auction-grad-" + id, x1: "33.598%", x2: "89.699%", y1: "113.932%", y2: "3.534%" },
            React.createElement("stop", { offset: "0%", stopColor: "#FF5050" }),
            React.createElement("stop", { offset: "54.2%", stopColor: "#FF7B0E" }),
            React.createElement("stop", { offset: "100%", stopColor: "#FF8400" }))),
    React.createElement("path", { fill: "url(#auction-grad-" + id + ")", fillRule: "nonzero", d: "M2.479 33.769a1.208 1.208 0 0 1 1.137-1.614h9.642a1.208 1.208 0 0 1 1.137 1.614h1.274c.665 0 1.205.542 1.205 1.21 0 .669-.54 1.211-1.205 1.211H1.205A1.208 1.208 0 0 1 0 34.98c0-.669.54-1.211 1.205-1.211H2.48zm21.243-18.146L38.855 28.58a3.28 3.28 0 0 1 .19 4.8 3.244 3.244 0 0 1-4.78-.191l-12.895-15.2a58.076 58.076 0 0 1-4.974 4.113l-6.464-6.492a50.195 50.195 0 0 1 5.22-6.17 50.087 50.087 0 0 1 6.145-5.245l6.463 6.492a57.905 57.905 0 0 1-4.038 4.938zM21.687.591a2.002 2.002 0 0 1 2.84 0l6.25 6.278a2.025 2.025 0 0 1 0 2.854 2.005 2.005 0 0 1-2.84 0l-6.25-6.278a2.023 2.023 0 0 1 0-2.853V.59zM6.345 16.003a2.003 2.003 0 0 1 2.84 0l6.819 6.849a2.025 2.025 0 0 1 0 2.854 2.003 2.003 0 0 1-2.841 0l-6.818-6.85a2.025 2.025 0 0 1 0-2.853zm5.966 3.14l.569-.572 3.977 3.996-.569.569-3.977-3.996v.003zM24.243 7.156l.568-.57 3.978 3.995-.568.57-3.978-3.995z" }))); };


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(1);
exports.BigColorizedIcon = function (id, props) { return (React.createElement("svg", tslib_1.__assign({}, props, { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", viewBox: "0 0 40 40" }),
    React.createElement("defs", null,
        React.createElement("linearGradient", { id: "colorized-grad-" + id, x1: "48.834%", x2: "48.834%", y1: "100.007%", y2: ".007%" },
            React.createElement("stop", { offset: "0%", stopColor: "#FF5050" }),
            React.createElement("stop", { offset: "54.2%", stopColor: "#FF7B0D" }),
            React.createElement("stop", { offset: "100%", stopColor: "#FF8400" }))),
    React.createElement("path", { fill: "url(#colorized-grad-" + id + ")", fillRule: "nonzero", d: "M11.833 11.641l-3.738 3.744a.94.94 0 0 0 0 1.324c1.742 1.745 3.429 4.677 3.016 6.993-.214 1.207-.981 2.098-2.343 2.727C3.86 28.698.612 31.842.078 34.841a4.992 4.992 0 0 0-.078.81v.088c.012 1.125.445 2.141 1.278 2.975l.008.01c.839.836 1.863 1.268 2.995 1.276h.059c.273-.002.546-.027.829-.078 2.995-.535 6.136-3.788 8.4-8.704.634-1.364 1.522-2.131 2.731-2.347 2.313-.412 5.24 1.278 6.986 3.02a.936.936 0 0 0 1.317 0v-.009l1.81-1.815-2.673-2.683a.889.889 0 0 1 0-1.258.887.887 0 0 1 1.254-.01l2.673 2.673.673-.673a.94.94 0 0 0 0-1.32L13.158 11.64a.93.93 0 0 0-1.317-.003l-.004.004-.004.001zM2.3 37.698a2.603 2.603 0 0 1 0-3.678 2.594 2.594 0 0 1 3.668-.007l.007.007a2.603 2.603 0 0 1-1.836 4.44c-.69 0-1.352-.273-1.838-.76l-.001-.002zM25.45 0c-.795 0-1.543.31-2.107.873l-8.726 8.742 1.328 1.326L24.673 2.2c.338-.338.855-.42 1.278-.201l.003 2.995a.944.944 0 0 0 1.132.917l.552-.117-2.436 3.522a.938.938 0 0 0 .073 1.161.95.95 0 0 0 1.151.195L30.5 8.438l-.17.663a.941.941 0 0 0 .679 1.142c.16.039.33.039.49-.01l1.1-.322-.302 1.142a.939.939 0 0 0 .668 1.147.966.966 0 0 0 .536-.015l.761-.244-.253.703a.94.94 0 0 0 .868 1.262l3.073.059a1.09 1.09 0 0 1-.195 1.292l-8.732 8.75 1.337 1.328 8.732-8.742a2.997 2.997 0 0 0 .868-2.107c0-.767-.293-1.53-.868-2.107a.952.952 0 0 0-.649-.28l-2.205-.039.478-1.284a.94.94 0 1 0-1.17-1.22l-.972.314.283-1.069a.932.932 0 0 0-.254-.911.946.946 0 0 0-.917-.229l-1.122.322.3-1.17A.938.938 0 1 0 31.5 5.754L29.002 7.12l1.522-2.205a.96.96 0 0 0 .01-1.054.941.941 0 0 0-.976-.396l-1.727.361V1.532a.938.938 0 0 0-.273-.664A3.008 3.008 0 0 0 25.451 0z" }))); };


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(1);
exports.BigPayedIcon = function (id, props) { return (React.createElement("svg", tslib_1.__assign({}, props, { xmlns: "http://www.w3.org/2000/svg", width: "28", height: "37", viewBox: "0 0 28 37" }),
    React.createElement("defs", null,
        React.createElement("linearGradient", { id: "payed-grad-" + id, x1: "50.052%", x2: "50.052%", y1: "99.964%", y2: "-.022%" },
            React.createElement("stop", { offset: "0%", stopColor: "#FF5050" }),
            React.createElement("stop", { offset: "54.2%", stopColor: "#FF7B0D" }),
            React.createElement("stop", { offset: "100%", stopColor: "#FF8400" }))),
    React.createElement("path", { fill: "url(#payed-grad-" + id + ")", fillRule: "nonzero", d: "M4.89 0c-.238 0-.43.19-.43.428v17.606a.43.43 0 0 1-.427.43H1.236a.427.427 0 0 0-.428.427v3.26c0 .24.19.43.427.43H4.03c.237 0 .428.19.428.43v2.28c0 .24-.19.43-.427.43H1.24a.428.428 0 0 0-.428.43v3.25c0 .24.19.43.426.43H4.03c.237 0 .428.19.428.43v5.316c0 .236.192.428.43.428h3.924a.43.43 0 0 0 .43-.427V30.26c0-.237.19-.43.427-.43h15.29c.23 0 .43-.192.43-.43v-3.254c0-.236-.2-.428-.43-.428H9.67a.43.43 0 0 1-.43-.43V23.01a.43.43 0 0 1 .43-.43h3.633c5.142 0 8.224-1.234 10.694-3.705 2.005-2.006 3.19-4.883 3.19-8.023 0-3.958-1.65-6.733-4.32-8.585C20.607.67 17.777 0 13.51 0H4.89zm4.353 18.085V4.545c0-.237.192-.428.428-.428h3.53c3.04 0 4.89.36 6.43 1.386 1.75 1.13 2.57 3.035 2.57 5.502 0 2.265-.61 3.91-2.05 5.352-1.594 1.645-3.755 2.156-7.662 2.156h-2.81a.428.428 0 0 1-.426-.428h-.01z" }))); };


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(1);
exports.BigPremiumIcon = function (id, props) { return (React.createElement("svg", tslib_1.__assign({}, props, { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", viewBox: "0 0 40 40" }),
    React.createElement("defs", null,
        React.createElement("linearGradient", { id: "premium-grad-" + id, x1: "50.022%", x2: "50.022%", y1: "99.942%", y2: ".283%" },
            React.createElement("stop", { offset: "0%", stopColor: "#FF5050" }),
            React.createElement("stop", { offset: "54.2%", stopColor: "#FF7B0D" }),
            React.createElement("stop", { offset: "100%", stopColor: "#FF8400" })),
        React.createElement("linearGradient", { id: "premium-grad-b-" + id, x1: "50.052%", x2: "50.052%", y1: "100.027%", y2: ".001%" },
            React.createElement("stop", { offset: "0%", stopColor: "#FF5050" }),
            React.createElement("stop", { offset: "54.2%", stopColor: "#FF7B0D" }),
            React.createElement("stop", { offset: "100%", stopColor: "#FF8400" }))),
    React.createElement("g", { fill: "none", fillRule: "nonzero" },
        React.createElement("path", { fill: "url(#premium-grad-" + id + ")", d: "M3.527 29.132c-.515.427-1.124 1.133-1.676 2.24-.69 1.404-.73 2.34-.68 2.81.02.14.2.206.29.105 1.07-1.197 1.83-1.018 1.44-.114-.16.36-.55.865-1.11 1.404-.93.898-1.59 2.11-1.71 3.49-.01.13-.02.26-.02.39v.058c0 .218.02.44.06.66.02.138.2.196.28.098.57-.657 2.41-2.36 6.27-2.764 3.54-.42 4.46-2.49 4.66-3.1.38-1.17.28-2.19-.01-2.99-.054-.16-.282-.16-.31-.01-.155.85-.68 2.02-2.33 2.57-2.754.92-4.263 1.31-4.263 1.31s.83-1.38 1.035-3.12c.2-1.68.987-3.26 2.66-3.58.16-.03.16-.25 0-.31-.535-.2-1.102-.3-1.674-.31-.915 0-1.93.282-2.93 1.13", transform: "translate(0 -1)" }),
        React.createElement("path", { fill: "url(#premium-grad-b-" + id + ")", d: "M38.896 1.328c-.21-.21-.714-.32-1.426-.33h-.16c-3.35.036-10.84 2.142-15.15 6.452C16.82 12.787 12 20.357 12 20.357l-8.3-.237a.471.471 0 0 0-.32.108l-2.11 1.68c-.12.1-.19.246-.19.39 0 .185.1.354.27.44l5.02 2.72c.05.026.1.044.16.053l3.33.55c.12.02.23.08.3.17l.64.74 1.24 1.25 1.25 1.24.74.64c.09.08.15.19.17.3l.548 3.33c.01.06.028.11.054.16l2.72 5.02a.495.495 0 0 0 .83.08l1.678-2.11c.075-.09.11-.21.11-.32l-.24-8.3s7.57-4.82 12.91-10.16c5.34-5.335 7.3-15.562 6.12-16.74l-.034-.03v-.003zm-9.85 13.28c-.785.776-1.64 1.142-2.428 1.142-.58 0-1.12-.2-1.57-.577-.9-1.052-.79-2.632.56-3.994 1.36-1.38 2.72-1.27 3.74-.32.94 1.02 1.06 2.38-.32 3.74l.018.005v.004z", transform: "translate(0 -1)" })))); };


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(1);
exports.BigTop3Icon = function (id, props) { return (React.createElement("svg", tslib_1.__assign({}, props, { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", viewBox: "0 0 40 40" }),
    React.createElement("defs", null,
        React.createElement("linearGradient", { id: "top3-grad-" + id, x1: "50.016%", x2: "50.016%", y1: "100.016%", y2: ".016%" },
            React.createElement("stop", { offset: "0%", stopColor: "#FF5050" }),
            React.createElement("stop", { offset: "54.2%", stopColor: "#FF7B0D" }),
            React.createElement("stop", { offset: "100%", stopColor: "#FF8400" }))),
    React.createElement("path", { fill: "url(#top3-grad-" + id + ")", fillRule: "nonzero", d: "M20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20S31.046 0 20 0zm10.698 23.256h-6.512v7.442h-8.372v-7.442H9.302c.091-.463-.12-.852 0-.93L19.535 6.512a2.24 2.24 0 0 1 .93 0l10.233 15.814c.12.078-.091.467 0 .93z" }))); };


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
/* istanbul ignore next */
tslib_1.__exportStar(__webpack_require__(16), exports);


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(17), exports);


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(18), exports);


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(19), exports);


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(1);
var utils_1 = __webpack_require__(4);
var sort_1 = __webpack_require__(3);
var VasLabel_1 = __webpack_require__(20);
var VasList_1 = __webpack_require__(22);
var styles = __webpack_require__(24);
var MobileVasLabel_1 = __webpack_require__(25);
exports.MobileVasLabel = MobileVasLabel_1.MobileVasLabel;
var MobileVasList_1 = __webpack_require__(27);
exports.MobileVasList = MobileVasList_1.MobileVasList;
exports.PopupDirection = {
    CENTER: 'center',
    LEFT: 'left',
    RIGHT: 'right',
};
/**
 * Компонент для отображения примененного VAS в объявлении
 * Отображается в виде иконок примененных VAS и имени приоритетного VAS
 * При наведении отображается тултип с описанием примененных VAS
 */
var VasComponent = /** @class */ (function (_super) {
    tslib_1.__extends(VasComponent, _super);
    function VasComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.enteringTimer = null;
        _this.leavingTimer = null;
        _this.animateEntering = function () {
            _this.enteringTimer = window.setTimeout(function () {
                _this.setState({
                    animationClassname: 'enter',
                });
            }, 300);
        };
        _this.animateLeaving = function () {
            _this.leavingTimer = window.setTimeout(function () {
                _this.setState({
                    isVisible: false,
                });
            }, 300);
        };
        _this.clearAnimationTimeout = function (timerId) {
            if (timerId) {
                window.clearInterval(timerId);
            }
        };
        _this.handleContainerClick = function (e) {
            if (_this.props.onClick) {
                _this.props.onClick(e);
            }
        };
        _this.state = {
            animationClassname: 'leave',
            isHovered: false,
            isVisible: false,
            vasList: sort_1.sortVas(props.vasList, props.priorities),
        };
        return _this;
    }
    VasComponent.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.vasList && this.props.vasList.length !== nextProps.vasList.length) {
            this.setState({
                vasList: sort_1.sortVas(nextProps.vasList, this.props.priorities),
            });
        }
    };
    VasComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, className = _a.className, labelStyles = _a.labelStyles, isMLSearch = _a.isMLSearch, auctionBet = _a.auctionBet, labelStyle = _a.labelStyle;
        var _b = this.state, vasList = _b.vasList, isHovered = _b.isHovered;
        return (React.createElement("div", tslib_1.__assign({ onClick: this.handleContainerClick, onMouseEnter: function () { return _this.showPopup(); }, onMouseLeave: function () { return _this.hidePopup(); } }, utils_1.mergeStyles(styles['container'], className)),
            this.state.isVisible && this.renderPopup(),
            React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['label'], labelStyles)),
                React.createElement(VasLabel_1.VasLabel, { labelStyle: labelStyle, label: label, vasList: vasList, isHovered: isHovered, auctionBet: auctionBet, isMLSearch: isMLSearch }))));
    };
    VasComponent.prototype.componentWillUnmount = function () {
        this.clearAnimationTimeout(this.enteringTimer);
        this.clearAnimationTimeout(this.leavingTimer);
    };
    VasComponent.prototype.renderPopup = function () {
        var _a = this.props, direction = _a.direction, uniqueKey = _a.uniqueKey, isMLSearch = _a.isMLSearch;
        var vasList = this.state.vasList;
        return (React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['popup-container'], styles["popup-container--" + direction], styles[this.state.animationClassname])),
            React.createElement("div", { className: styles['popup'] },
                React.createElement("div", { className: styles['popup-content'] },
                    React.createElement(VasList_1.VasList, { isMLSearch: isMLSearch, vasList: vasList, uniqueKey: uniqueKey })))));
    };
    VasComponent.prototype.showPopup = function () {
        this.clearAnimationTimeout(this.leavingTimer);
        this.setState({
            animationClassname: 'entering',
            isHovered: true,
            isVisible: true,
        }, this.animateEntering);
    };
    VasComponent.prototype.hidePopup = function () {
        this.clearAnimationTimeout(this.enteringTimer);
        this.setState({
            animationClassname: 'leave',
            isHovered: false,
        }, this.animateLeaving);
    };
    VasComponent.defaultProps = {
        direction: exports.PopupDirection.LEFT,
    };
    return VasComponent;
}(React.Component));
exports.VasComponent = VasComponent;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(1);
var utils_1 = __webpack_require__(4);
var name_1 = __webpack_require__(2);
var auction_1 = __webpack_require__(5);
var colorized_1 = __webpack_require__(6);
var payed_1 = __webpack_require__(7);
var premium_1 = __webpack_require__(8);
var top3_1 = __webpack_require__(9);
var styles = __webpack_require__(21);
/**
 * Компонент для отображения примененных VAS в виде иконок примененных VAS и названия приоритетного VAS
 */
var VasLabel = /** @class */ (function (_super) {
    tslib_1.__extends(VasLabel, _super);
    function VasLabel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getVasIcon = function (vas, isHovered) {
            switch (vas) {
                case 'top3': return top3_1.LittleTop3Icon(!!isHovered);
                case 'auction': return auction_1.LittleAuctionIcon(!!isHovered);
                case 'premium': return premium_1.LittlePremiumIcon(!!isHovered);
                case 'payed': return payed_1.LittlePayedIcon(!!isHovered);
                case 'colorized': return colorized_1.LittleColorizedIcon(!!isHovered);
                default: return null;
            }
        };
        return _this;
    }
    VasLabel.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, vasList = _a.vasList, isHovered = _a.isHovered, isMLSearch = _a.isMLSearch, auctionBet = _a.auctionBet, labelStyle = _a.labelStyle;
        var auctionBetText = !!auctionBet && " + " + auctionBet + " \u20BD";
        var computedLabel = isMLSearch ? name_1.getMlTopVasName(vasList) : name_1.getTopVasName(vasList);
        return (React.createElement("div", { className: styles['container'] },
            React.createElement("div", { className: styles['icons'] }, vasList.map(function (vas) {
                return (React.createElement("div", { className: styles['icon'], key: vas }, _this.getVasIcon(vas, isHovered)));
            })),
            React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['name'], isHovered && styles['name--hovered'], labelStyle)),
                label || computedLabel,
                auctionBetText)));
    };
    return VasLabel;
}(React.Component));
exports.VasLabel = VasLabel;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"vas_tooltip_component-container-6RPGhNXg","name":"vas_tooltip_component-name-ntRmzX78","name--hovered":"vas_tooltip_component-name--hovered-mTLzaZoL","icons":"vas_tooltip_component-icons-hyU6QRhi","icon":"vas_tooltip_component-icon-g1xJKs81"};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(1);
var name_1 = __webpack_require__(2);
var auction_1 = __webpack_require__(10);
var colorized_1 = __webpack_require__(11);
var payed_1 = __webpack_require__(12);
var premium_1 = __webpack_require__(13);
var top3_1 = __webpack_require__(14);
var styles = __webpack_require__(23);
/**
 * Компонент для отображения списка примененных VAS с описанием каждого VAS
 */
var VasList = /** @class */ (function (_super) {
    tslib_1.__extends(VasList, _super);
    function VasList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getVasIcon = function (vas, id) {
            switch (vas) {
                case 'top3': return top3_1.BigTop3Icon(id);
                case 'auction': return auction_1.BigAuctionIcon(id);
                case 'premium': return premium_1.BigPremiumIcon(id);
                case 'payed': return payed_1.BigPayedIcon(id, { style: { width: 40 } });
                case 'colorized': return colorized_1.BigColorizedIcon(id);
                default: return null;
            }
        };
        return _this;
    }
    VasList.prototype.render = function () {
        var _this = this;
        var _a = this.props, vasList = _a.vasList, uniqueKey = _a.uniqueKey, isMLSearch = _a.isMLSearch;
        return (React.createElement("div", { className: styles['container'] },
            React.createElement("div", { className: styles['header'] }, "\u041A \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044E \u043F\u0440\u0438\u043C\u0435\u043D\u0435\u043D\u044B \u043E\u043F\u0446\u0438\u0438:"),
            React.createElement("div", { className: styles['list'] }, vasList.map(function (vas) {
                return (React.createElement("div", { className: styles['vas'], key: vas },
                    React.createElement("div", { className: styles['icon'] }, _this.getVasIcon(vas, uniqueKey)),
                    React.createElement("div", { className: styles['description'] },
                        React.createElement("div", { className: styles['description-header'] }, isMLSearch ? name_1.getMlVasName(vas, true) : name_1.getVasName(vas, true)),
                        React.createElement("div", { className: styles['text'] }, isMLSearch ? name_1.getMlVasDescription(vas) : name_1.getVasDescription(vas)))));
            })),
            React.createElement("div", { className: styles['link'] },
                React.createElement("a", { href: "https://www.cian.ru/promo/adv/", target: "_blank", className: styles['link-tag'] }, "\u0423\u0437\u043D\u0430\u0442\u044C \u043F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435"))));
    };
    return VasList;
}(React.Component));
exports.VasList = VasList;


/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"vas_tooltip_component-container-cVpimvPW","header":"vas_tooltip_component-header-pix0ZVE8","vas":"vas_tooltip_component-vas-QyGLaBk4","icon":"vas_tooltip_component-icon-1l3KuFET","description":"vas_tooltip_component-description-6DPNiank","description-header":"vas_tooltip_component-description-header-9EAmnIL8","link":"vas_tooltip_component-link-7A0PnOUf","link-tag":"vas_tooltip_component-link-tag-IKTOJoW7"};

/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"vas_tooltip_component-container-C5Vwwx23","entering":"vas_tooltip_component-entering-1aCVgLxFq","enter":"vas_tooltip_component-enter-ixrG92Np","label":"vas_tooltip_component-label-LkcT08S6","leave":"vas_tooltip_component-leave-1gQ0qDSJB","label--disabled":"vas_tooltip_component-label--disabled-1eiwTQ63a","label--popup-disabled":"vas_tooltip_component-label--popup-disabled-1bCueYMYK","popup-container":"vas_tooltip_component-popup-container-fomJFXiX","popup-container--left":"vas_tooltip_component-popup-container--left-MfduZz5t","popup-container--right":"vas_tooltip_component-popup-container--right-THFzTm0Z","popup-container--center":"vas_tooltip_component-popup-container--center-14hvOqEEy","popup":"vas_tooltip_component-popup-7GahphTO","popup-content":"vas_tooltip_component-popup-content-Y8FfRbK8","link":"vas_tooltip_component-link-YHrSBbvC"};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(1);
var name_1 = __webpack_require__(2);
var sort_1 = __webpack_require__(3);
var auction_1 = __webpack_require__(5);
var colorized_1 = __webpack_require__(6);
var payed_1 = __webpack_require__(7);
var premium_1 = __webpack_require__(8);
var top3_1 = __webpack_require__(9);
var styles = __webpack_require__(26);
/**
 * Компонент для отображения примененных VAS в виде иконок примененных VAS и названия приоритетного VAS
 * Адаптирован под мобильный сайт
 */
var MobileVasLabel = /** @class */ (function (_super) {
    tslib_1.__extends(MobileVasLabel, _super);
    function MobileVasLabel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getVasIcon = function (vas) {
            var isHovered = _this.props.isHovered;
            switch (vas) {
                case 'top3': return top3_1.LittleTop3Icon(!!isHovered);
                case 'auction': return auction_1.LittleAuctionIcon(!!isHovered);
                case 'premium': return premium_1.LittlePremiumIcon(!!isHovered);
                case 'payed': return payed_1.LittlePayedIcon(!!isHovered);
                case 'colorized': return colorized_1.LittleColorizedIcon(!!isHovered);
                default: return null;
            }
        };
        return _this;
    }
    MobileVasLabel.prototype.render = function () {
        var _this = this;
        var _a = this.props, vasList = _a.vasList, isMLSearch = _a.isMLSearch;
        var sortedVas = sort_1.sortVas(vasList);
        return (React.createElement("div", { className: styles['container'] },
            React.createElement("div", { className: styles['icons'] }, sortedVas.map(function (vas) {
                return (React.createElement("div", { className: styles['icon'], key: vas }, _this.getVasIcon(vas)));
            })),
            React.createElement("div", { className: styles['name'] }, isMLSearch ? name_1.getMlTopVasName(sortedVas) : name_1.getTopVasName(sortedVas))));
    };
    return MobileVasLabel;
}(React.Component));
exports.MobileVasLabel = MobileVasLabel;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"vas_tooltip_component-container-9ySA0pac","name":"vas_tooltip_component-name-n9Sz9UBe","icons":"vas_tooltip_component-icons-xJuwJjpH","icon":"vas_tooltip_component-icon-geROvQZH"};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(1);
var name_1 = __webpack_require__(2);
var sort_1 = __webpack_require__(3);
var auction_1 = __webpack_require__(10);
var colorized_1 = __webpack_require__(11);
var payed_1 = __webpack_require__(12);
var premium_1 = __webpack_require__(13);
var top3_1 = __webpack_require__(14);
var styles = __webpack_require__(28);
/**
 * Компонент для отображения списка примененных VAS с описанием каждого VAS
 * Адаптирован под мобильный сайт
 */
var MobileVasList = /** @class */ (function (_super) {
    tslib_1.__extends(MobileVasList, _super);
    function MobileVasList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getVasIcon = function (vas, id) {
            switch (vas) {
                case 'top3': return top3_1.BigTop3Icon(id, { style: { width: 30, height: 30 } });
                case 'auction': return auction_1.BigAuctionIcon(id, { style: { width: 30, height: 30 } });
                case 'premium': return premium_1.BigPremiumIcon(id, { style: { width: 30, height: 30 } });
                case 'payed': return payed_1.BigPayedIcon(id, { style: { width: 30, height: 30 } });
                case 'colorized': return colorized_1.BigColorizedIcon(id, { style: { width: 30, height: 30 } });
                default: return null;
            }
        };
        return _this;
    }
    MobileVasList.prototype.render = function () {
        var _this = this;
        var _a = this.props, vasList = _a.vasList, uniqueKey = _a.uniqueKey, isMLSearch = _a.isMLSearch;
        var sortedVas = sort_1.sortVas(vasList);
        return (React.createElement("div", { className: styles['container'] },
            React.createElement("div", { className: styles['list'] }, sortedVas.map(function (vas) {
                return (React.createElement("div", { className: styles['vas'], key: vas },
                    React.createElement("div", { className: styles['icon'] }, _this.getVasIcon(vas, uniqueKey)),
                    React.createElement("div", { className: styles['description'] },
                        React.createElement("div", { className: styles['description-header'] }, isMLSearch ? name_1.getMlVasName(vas, true) : name_1.getVasName(vas, true)),
                        React.createElement("div", { className: styles['text'] }, isMLSearch ? name_1.getMlVasDescription(vas) : name_1.getVasDescription(vas)))));
            }))));
    };
    return MobileVasList;
}(React.Component));
exports.MobileVasList = MobileVasList;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"vas_tooltip_component-container-vKQuNPby","vas":"vas_tooltip_component-vas-2ICIPtcQ","icon":"vas_tooltip_component-icon-WW7bkNL0","description":"vas_tooltip_component-description-R8Byqr3A","description-header":"vas_tooltip_component-description-header-PquaKVtO","text":"vas_tooltip_component-text-11QbD6fKD"};

/***/ })
/******/ ]);
//# sourceMappingURL=frontend-vas-tooltip-component.js.map